// 進行異步執行
import {
  apiTcmktGetUrl,
  apiTradingContestEligibility,
  apiGetTradingContestParticipantInfo,
  apiGetFirstAccountAuditStatus,
  apiGet_last_identifiy_proof,
  apiCampaignInfo,
  apiGetSessionId,
} from '@/resource'
import { apiID3Status } from '@/resource/register'
import auditStatus, { getAuditStatusByNumber, getAuditStatusByString } from '@/constants/auditStatus'
import fileType from '@/constants/fileType'
import auditType from '@/constants/register/auditType'
import poiStore from '../register/poiVerification/poiStore'
import poaStore from '../register/poaVerification/poaStore'
import ibtStore from '../register/ibtVerification/ibtStore'

export default {
  async actionTradingToolUrl({ commit, state }, lang) {
    if (state.tradingToolUrl.length > 0) return
    return new Promise((resolve, reject) => {
      apiTcmktGetUrl().then(result => {
        commit('setTradingToolUrl', result.data.data)
        resolve(result.data.data)
      })
    })
  },
  async actionAccountAuditStatus({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGetFirstAccountAuditStatus()
        .then(response => {
          commit('setAccountAuditStatus', auditStatus.init)
          if (response.data.code === 0 && response.data?.data) {
            const accountAuditStatus = getAuditStatusByString(response.data.data)
            commit('setAccountAuditStatus', accountAuditStatus)
            resolve(accountAuditStatus)
          }
          resolve(auditStatus.init)
        })
        .catch(e => {
          resolve(auditStatus.init)
        })
    })
  },
  async actionPoiAuditStatus({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      const responses = await Promise.all([apiGet_last_identifiy_proof(fileType.poi), apiID3Status()])
      const idProofResponse = responses[0]
      const id3Response = responses[1]

      if ((id3Response.data?.data ?? null) !== null) {
        commit('setId3Pass', id3Response.data.data)
      }

      if (idProofResponse.data?.code === 0 && idProofResponse.data?.data) {
        const data = idProofResponse.data?.data
        const poiAuditStatus = getAuditStatusByNumber(data.status) ?? state.poiAuditStatus
        if (poiAuditStatus === auditStatus.pending) {
          await poiStore.dispatch('setIdPendingInfo', {
            poiRecordId: data.id,
            poiPendingRecord: data.value,
            poiPendingReason: data.pending_reason !== 7 ? data.pending_reason_text ?? '' : '',
            poiCustomPendingReason: data.pending_reason === 7 ? data.custom_pending_reason ?? '' : '',
          })
        } else {
          await poiStore.dispatch('setIdPendingInfo', {})
        }
        commit('setPoiAuditStatus', poiAuditStatus)
      }

      resolve(idProofResponse.data?.data ?? null)
    })
  },
  async actionPoaAuditStatus({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGet_last_identifiy_proof(fileType.poa)
        .then(async resp => {
          if (resp.data?.code === 0 && resp.data?.data) {
            const data = resp.data?.data
            const poaAuditStatus = getAuditStatusByNumber(data.status) ?? state.poaAuditStatus

            if (poaAuditStatus === auditStatus.pending) {
              await poaStore.dispatch('setPoaPendingInfo', {
                poaRecordId: data.id,
                poaPendingRecord: data.value,
                poaPendingReason: data.pending_reason !== 7 ? data.pending_reason_text ?? '' : '',
                poaCustomPendingReason: data.pending_reason === 7 ? data.custom_pending_reason ?? '' : '',
              })
            } else {
              await poaStore.dispatch('setPoaPendingInfo', {})
            }
            commit('setPoaAuditStatus', poaAuditStatus)
          }

          resolve(resp.data?.data ?? null)
        })
        .catch(e => {
          resolve(null)
        })
    })
  },
  async actionIbtPoiAuditStatus({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGet_last_identifiy_proof(fileType.poi, auditType.ibt)
        .then(async resp => {
          if (resp.data?.code === 0 && resp.data?.data) {
            const data = resp.data?.data
            const ibtPoiAuditStatus = getAuditStatusByNumber(data.status) ?? state.ibtPoiAuditStatus
            if (ibtPoiAuditStatus === auditStatus.pending) {
              await ibtStore.dispatch('setIdPendingInfo', {
                poiRecordId: data.id,
                poiPendingRecord: data.value,
                poiPendingReason: data.pending_reason !== 7 ? data.pending_reason_text ?? '' : '',
                poiCustomPendingReason: data.pending_reason === 7 ? data.custom_pending_reason ?? '' : '',
              })
            } else {
              await ibtStore.dispatch('setIdPendingInfo', {})
            }
            commit('setIbtPoiAuditStatus', ibtPoiAuditStatus)
          }

          resolve(resp.data?.data ?? null)
        })
        .catch(e => {
          resolve(null)
        })
    })
  },
  async actionIbtPoaAuditStatus({ commit, state }) {
    return new Promise((resolve, reject) => {
      apiGet_last_identifiy_proof(fileType.poa, auditType.ibt)
        .then(async resp => {
          if (resp.data?.code === 0 && resp.data?.data) {
            const data = resp.data?.data
            const ibtPoaAuditStatus = getAuditStatusByNumber(data.status) ?? state.ibtPoaAuditStatus

            if (ibtPoaAuditStatus === auditStatus.pending) {
              await ibtStore.dispatch('setPoaPendingInfo', {
                poaRecordId: data.id,
                poaPendingRecord: data.value,
                poaPendingReason: data.pending_reason !== 7 ? data.pending_reason_text ?? '' : '',
                poaCustomPendingReason: data.pending_reason === 7 ? data.custom_pending_reason ?? '' : '',
              })
            } else {
              await ibtStore.dispatch('setPoaPendingInfo', {})
            }
            commit('setIbtPoaAuditStatus', ibtPoaAuditStatus)
          }

          resolve(resp.data?.data ?? null)
        })
        .catch(e => {
          resolve(null)
        })
    })
  },
  updateCheckedAuthStatus({ commit }, values) {
    commit('setCheckedAuthStatus', values)
  },
  async actionApiGetSessionId({ commit, state }) {
    let res = await apiGetSessionId()
    if (res.data.code === 0 && res.data.data) {
      commit('setSessionId', res.data.data)
    }
  },
}
